import { parseQuery } from '@calendly/http-tools'


export const buildAnswers = () => {
  const query = parseQuery(window.location.search)
  const answers = {}
  for (const key in query) {
    if (Object.prototype.hasOwnProperty.call(query, key)) {
      const match = key.match(/^a(\d+)$/)
      if (match) {
        answers[match[1]] = query[key]
      }
    }
  }
  return answers
}
